/* eslint-disable no-unused-vars */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable array-callback-return */
/* eslint-disable react-hooks/exhaustive-deps */
import { Box, Drawer, Paper, useMediaQuery } from "@mui/material";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { openDrawer } from "../../shared/state/slices/menu.js";
import Sidebar from "./sidebar/index.jsx";
import { menuItems } from "../navigation.jsx";
const Layout = ({ children }) => {
  const [loading, setLoading] = useState(false);
  const [userInfo, setuserInfo] = useState({});
  const [viewALl, setViewALl] = useState(true);
  const [headerMenu, setHeaderMenu] = useState([]);

  const dispatch = useDispatch();
  const { userPermissions: userPermissionsSelector } = useSelector(
    (state) => state.relationals
  );
  const { openDrawer: openDrawerSelector } = useSelector(
    (state) => state.openDrawer
  );
  const { themeColor } = useSelector((state) => state.themeColor);
  const { companyInfo } = useSelector((state) => state.relationals);

  var dark = themeColor === "dark";
  const user = useSelector((state) => state.user);

  const location = useLocation();


  const isMd = useMediaQuery("(min-width:900px)");

  if (location?.pathname === "/invoices") {
    return <> {children}</>;
  }
  return (
    <Box className="main">
      {loading ? (
        <>
          <Paper
            className="
      fixed top-1/2 right-1/2 -translate-y-1/2 translate-x-1/2
      md:w-full w-[90%] h-full max-h-[200px] max-w-[400px] flex justify-center
      items-center flex-col   rounded-2xl py-4 px-7 shadow-2xl"
            style={{ zIndex: 1000000 }}
          >
            {dark ? (
              <img
                src={`/images/logo.svg`}
                alt="logo"
                style={{ width: "150px" }}
              />
            ) : (
              <img
                src={`/images/logo.svg`}
                alt="logo"
                style={{ width: "150px" }}
              />
            )}
            {/*   <span className="text-sm text-gray-700 mt-6">در حال انتقال به درگاه </span> */}
            <Box sx={{ position: "relative", width: "100%", height: "100%" }}>
              <span style={{ visibility: "hidden" }}>loading ....</span>
              <a className={"btn btn--loading"}>
                <span>
                  <b></b>
                  <b></b>
                  <b></b>
                </span>
              </a>
            </Box>
          </Paper>
          <div
            style={{ background: dark ? "#0e102d" : "#fff" }}
            className="loadingPage"
          ></div>
        </>
      ) : (
        <>
          {isMd ? (
            <Sidebar
              headerMenu={menuItems}
              setViewALl={setViewALl}
              viewALl={viewALl}
            />
          ) : (
            <Drawer
              anchor="right"
              open={openDrawerSelector}
              onClose={() => dispatch(openDrawer(false))}
            >
              <Sidebar
                headerMenu={menuItems}
                setViewALl={setViewALl}
                viewALl={viewALl}
              />
            </Drawer>
          )}

          <Box
            className={`transition-all min-h-[100vh] ${
              themeColor === "dark" ? "darkMode" : ""
            }`}
            sx={{
              pl: isMd ? (viewALl ? "13.75rem" : "4rem") : 0,
              bgcolor: "background.default",
            }}
          >
            {children}
          </Box>
        </>
      )}
    </Box>
  );
};

export default Layout;
